import axios from "axios"

export default class AwsApi {
  static uploadCsv(formData, url) {
    return axios.post(url, formData)
  }
}
